import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../base-component/base.component';
import { BaseDialogData } from './base-dialog-data.interface';

@Component({
  selector: 'app-base-dialog',
  templateUrl: './base-dialog.component.html',
})
export class BaseDialogComponent extends BaseComponent {
  constructor(
    public dialogRef: MatLegacyDialogRef<BaseDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA)
    public data: BaseDialogData
  ) {
    super();
  }

  primaryClick() {
    this.dialogRef.close(true);
  }

  secondaryClick() {
    this.dialogRef.close(false);
  }

  close() {
    this.dialogRef.close(null);
  }
}
